export default __webpack_public_path__ + "static/media/sbu-2021-m700b-galleryimages-5-210129.1211d6d6.jpg";